// import './modernizer-custom';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/carousel';
import '../scss/bootstrap.scss';
import '../scss/app.scss';
import Headroom from "headroom.js";
import LazyLoad from "vanilla-lazyload";
import './checkbox-dropdown';
// import Rellax from "rellax";
// Event tracking: set up in tag manager

$(function () {
    // iOS active link fix
    // https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
    document.querySelector('body').ontouchstart = '';
    document.addEventListener("touchstart", function () { }, false);

    // No focus styles for non-tabbing users
    // See: https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
    // See: src/scss/_base, 'No focus styles for non-tabbing users' section
    function handleFirstTab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
        }
    }
    window.addEventListener('keydown', handleFirstTab);

    $('body').removeClass('no-js');

    // Image lazy load
    var lazyLoad = new LazyLoad({
        elements_selector: ".lazy"
    });

    // Headroom - header animation
    const headroom  = new Headroom(document.querySelector('header.site-header'), {
        offset: 225,
        tolerance: {
            down: 40,
            up: 20
        },
        onUnpin: function() {
            $('.js-search-overlay').removeClass('open');
            $('.js-search-trigger').removeClass('js-search-trigger--open');

            $('.js-search-overlay').find('input[type="text"]').blur();
        },
    });
    headroom.init();

    // Navigation active state handling
    var currentPageId = $('body').attr('data-page-id');
    if (currentPageId) {
        var $activeSubitem = $('.navbar .dropdown-item-' + currentPageId);
        if ($activeSubitem.length) {
            if (!$activeSubitem.hasClass('dropdown-item--top')) {
                // Don't set active states on the first sub as it is the top level
                $activeSubitem.addClass('active');
            }
            var $parent = $activeSubitem.parent().parent();
            if ($parent.hasClass('dropdown-menu')) {
                // We are inside the partners menu so lets go up one more
                $parent = $parent.parent();
            }
            
            $parent.addClass('active');
        } else {
            // Try items with no sublevels
            //console.log('Searching nonsubs');
            var $activeNavItem = $('.nav-item.nav-item-' + currentPageId);
            if ($activeNavItem.length) {
                //console.log('x');
                $activeNavItem.addClass('active');
            }
        }
    }

    let clientWidth = document.documentElement.clientWidth;

    if (clientWidth >= 768) {
        var $heroBanner = $('.hero.hero--default');

        if ($heroBanner.length) {

            // Preload all images by setting display block.
            // $('.hero__image img').show();

            var outHoverTimer = null;

            $('[data-hero-hover]').hover(function () {
                if (outHoverTimer !== null) {
                    clearTimeout(outHoverTimer);
                    outHoverTimer = null;
                }

                var currentStyle = $heroBanner.data('for');
                var newStyle = $(this).data('hero-hover');

                // TODO: do a opacity change instead with a transition so it looks nice
                if (currentStyle !== newStyle) {
                    $heroBanner.data('for', newStyle);
                    $heroBanner.removeClass('hero--' + currentStyle).addClass('hero--' + newStyle);
                    $('.hero__image img:not([data-for="' + newStyle + '"])').hide();
                    $('.hero__image img[data-for="' + newStyle + '"]').show();

                    // Update lazy load because it does not load images that are display:none
                    lazyLoad.update();
                }
            }, function () {
                outHoverTimer = setTimeout(function () {
                var currentStyle = $heroBanner.data('for');
                var newStyle = 'default';

                    if (currentStyle !== newStyle) {
                        $heroBanner.data('for', newStyle);
                        $heroBanner.removeClass('hero--' + currentStyle).addClass('hero--' + newStyle);
                        $('.hero__image img:not([data-for="' + newStyle + '"])').hide();
                        $('.hero__image img[data-for="' + newStyle + '"]').show();

                        // Update lazy load because it does not load images that are display:none
                        lazyLoad.update();
                    }
                }, 200);
            });
        }
    }

    // Star parralax
    // if (clientWidth >= 500) {
    //     var starRellax = new Rellax('.star--animate', {
    //         speed: 1
    //     });
    // }

    $('#navReveal').on('show.bs.collapse', function () {
        $('.site-header__expand span').text('Close');

        // Close to search overlay
        $('.js-search-overlay').removeClass('open');
        $('.js-search-trigger').removeClass('js-search-trigger--open');
        $('.js-search-overlay').find('input[type="text"]').blur();
        $('body').addClass('navbar-open');
    });

    $('#navReveal').on('hide.bs.collapse', function () {
        $('.site-header__expand span').text('Menu');
        $('body').removeClass('navbar-open');
    });

    // Footer itag links
    if (window.location.pathname == '/') {
        document.querySelectorAll('.footer__itag').forEach(elem => {
          elem.setAttribute('rel', 'noopener');
        });
    } else {
        document.querySelectorAll('.footer__itag').forEach(elem => {
            elem.setAttribute('rel', 'noopener nofollow');
        });
    }
    
    // Homepage video
    var videoSrc;  
    $('.js-set-video-src').click(function() {
        videoSrc = $(this).data("src");
    });

    // When the modal is opened autoplay it  
    $('#ltiVideoModal').on('shown.bs.modal', function (e) {
        // Set the video src to autoplay and not to show related video. Youtube related video is like a box of chocolates... you never know what you're gonna get
        $("#ltiVideoModal iframe").attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"); 
    });

    // stop playing the youtube video when I close the modal
    $('#ltiVideoModal').on('hide.bs.modal', function (e) {
        // A poor man's stop video
        $("#ltiVideoModal iframe").attr('src', videoSrc); 
    });

    // Add required class to labels
    $('.form input, .form textarea, .form select').filter('[required]:visible').each(function () {
        if ($(this).is(':radio') || $(this).is(':checkbox')) {
            return;
        }

        var $label = $(this).parent().find('label');
        if ($label.length > 0) {
            $label.addClass('required');
        }
    });

    // SIL and SDA listing
    $('.js-vacancy-enquire').click(function (e) {
        e.preventDefault();
        $("html, body").stop().animate(
            {
                scrollTop: $('#vacancyForm').offset().top,
            },
            600
        );
        $('input[name="firstName"]').focus();
    });

    // Update CSRF tokens on cached pages
    (function () {
        fetch("/index.php?p=actions/users/session-info", {
        headers: {
            Accept: "application/json",
        },
        })
        .then((response) => response.json())
        .then((data) => {
            window.csrfTokenName = data.csrfTokenName;
            window.csrfTokenValue = data.csrfTokenValue;

            // Update CSRF token on cached pages
            if (window.csrfTokenName && window.csrfTokenValue) {
            document
                .querySelectorAll('input[name="' + window.csrfTokenName + '"]')
                .forEach((tokenField) => {
                tokenField.value = window.csrfTokenValue;
                });
            }
        });
    })();

    var $vacancyFormWrapper = $('#vacancyForm');
    // SIL form
    // if ($vacancyFormWrapper.length && $vacancyFormWrapper.data('sil-id')) {
    //     $(this).find('input[name="ID"]').val("SIL" + $vacancyFormWrapper.data('sil-id'));
    //     $(this).find('input[name="URL"]').val($vacancyFormWrapper.data('sil-url'));
    //     if ($vacancyFormWrapper.data('site-name')) {
    //         $(this).find('input[name="SiteName"]').val($vacancyFormWrapper.data('site-name'));
    //     }
    // }

    // SDA form
    if ($vacancyFormWrapper.length && $vacancyFormWrapper.data('sda-id')) {
        $(this).find('input[name="ID"]').val("SDA" + $vacancyFormWrapper.data('sda-id'));
        $(this).find('input[name="URL"]').val($vacancyFormWrapper.data('sda-url'));
        if ($vacancyFormWrapper.data('site-name')) {
            $(this).find('input[name="SiteName"]').val($vacancyFormWrapper.data('site-name'));
        }
    }

    // Search
    $('.js-search-trigger').click(function(e) {
        e.preventDefault();
        if ($('.search-form #searchField').length) {
            $('.search-form #searchField').focus();
        } else {
            var $searchOverlay = $('.js-search-overlay');
            var isOpen = $searchOverlay.hasClass('open');
            var $searchField = $searchOverlay.find('input[type="search"]');

            $searchOverlay.toggleClass('open');

            $(this).toggleClass('js-search-trigger--open');
            $(this).attr('title', isOpen ? 'Hide search bar' : 'Show search bar');
            $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
            
            if (isOpen) {
                $searchField.blur();
            } else {
                setTimeout(function () {
                $searchField.focus();
                }, 150);

                // We are opening, so close the main nav
                $('#navReveal').collapse('hide');
            }
        }
    });

    // Page name in forms
    var $pageNameField = $('input[name="pageName"]');
    if ($pageNameField.length) {
        var $lastBreadcrumb = $('.breadcrumbs a').last();
        if ($lastBreadcrumb) {
            $pageNameField.val($lastBreadcrumb.text());
        } else {
            $pageNameField.val($('body h1').first().text());
        }
    }

    // Show required label on radio button group label, not individual labels
    $(
      '.wf-group input[type="radio"][required], .wf-group input[type="checkbox"][required]',
    ).each(function () {
      var $parentGroup = $(this).parent().parent();
      if (!$parentGroup.hasClass("wf-group")) {
        return;
      }

      $parentGroup
        .find(".wf-group-heading label.wf-label")
        .addClass("required");
    });

    // BP dropdown fake select
    $('.solutions-dropdown .dropdown-menu a').on('click', function() {
        $('.solutions-dropdown button span:first-of-type').text($(this).text());
    });

    // APM modal
    var $apmRegisterForm = $('.site-apm .component.form.form-5');
    if ($apmRegisterForm.length && $apmRegisterForm.find('.form-tandc-trigger').length) {
        var $legalsModal = $(".register-form-accept-tandc-modal");
        if ($legalsModal.length) {

            // Bring closer to hidden checkbox
            $('.form-tandc-trigger').parent().css('margin-bottom', '0px');

            //$apmRegisterForm.find('input[name="AcceptTerms[]"]')[0].setCustomValidity('Please accept the Terms & Conditions');

            // Hide the checkbox
            $('.form-tandc-trigger').parent().next().addClass('hidden-tandc-checkbox');

            // Scroll to modal footer
            $('.register-form-accept-tandc-modal__scroll a').on('click', function () {
                $legalsModal.stop().animate(
                    {
                        scrollTop: $('.register-form-accept-tandc-modal .modal-footer').offset().top,
                    },
                    750
                );
            });

            $apmRegisterForm.find('form').on('submit', function(e) {
                console.log('on submit');
                if (!$('input[name="AcceptTerms[]"]').is(':checked')) {
                    e.preventDefault();
                    $legalsModal.modal('show');
                    return false;
                }
                //console.log($apmRegisterForm.find('input[name="AcceptTerms[]"]')[0].checkValidity());
            })

            $('.js-register-form-accept-tandc-checkbox').on('change', function () {
                console.log('checked?', this.checked);
                if (this.checked) {
                    setTimeout(function () {
                        $apmRegisterForm.find('input[name="AcceptTerms[]"]').prop("checked", "checked");
                        $('.form-tandc-trigger p').show();
                        $('.form-tandc-trigger .btn').hide();
                        $legalsModal.modal('hide');
                        $('.js-register-form-accept-tandc-checkbox').prop("checked", false);
                    }, 320);
                    
                }
            });
        }
    }

    function wrapMatchInSpan(label, pattern, className = "") {
        const spanOpen = `<span${className ? ` class="${className}"` : ""}>`;
        label.innerHTML = label.innerHTML.replace(pattern, `${spanOpen}$&</span>`);
    }

    // Example: wrap anything in parentheses
    document.querySelectorAll(".form-8 label").forEach((label) => {
        wrapMatchInSpan(label, /\(.*?\)/, "label-note");
    });

    function toggleOnInput(inputType, inputName, inputValue, targetSelector, showWhen = true) {
        const inputs = document.querySelectorAll(
            `input[type="${inputType}"][name="${inputName}"][value="${inputValue}"]`
        );
        const target = document.querySelector(targetSelector);

        if (!inputs.length || !target) return;

        const update = (animate = true) => {
            const isChecked = [...inputs].some((input) => input.checked);
            let shouldShow = showWhen ? isChecked : !isChecked;

            target.hidden = !shouldShow;

            if (animate && shouldShow) {
                target.classList.remove("anim-reveal", "anim-hide");
                void target.offsetWidth; // force reflow so animation restarts if triggered again
                target.classList.add("anim-reveal");
            } else if (animate && !shouldShow) {
                target.classList.remove("anim-reveal", "anim-hide");
                void target.offsetWidth;
                target.classList.add("anim-hide");
            }
        };

        // For radio buttons, siblings with the same name can affect state,
        // so we listen on the whole document to catch deselection
        const allRelated = inputType === 'radio'
            ? document.querySelectorAll(`input[type="radio"][name="${inputName}"]`)
            : inputs;

        update(false);
        allRelated.forEach(input => input.addEventListener('change', update));
    }

    /*
    // Checkbox (same as before)
    toggleOnInput('checkbox', 'contact-preference', 'other', '#emergency-contact-fields');

    // Radio button — show when 'yes' is selected
    toggleOnInput('radio', 'has-emergency-contact', 'yes', '#emergency-contact-fields');

    // Radio button — hide when 'no' is selected
    toggleOnInput('radio', 'has-emergency-contact', 'no', '#emergency-contact-fields', false);
    */

    if (document.querySelector('.form-8')) {
        //toggleOnInput('radio', 'supportCoordination', 'Yes', '.group-funding-remaining');
        //toggleOnInput('radio', 'supportCoordination', 'No', '.group-funding-remaining', false);

        toggleOnInput('radio', 'howIsFundingManaged', 'Agency managed', '.group-plan-managed-by');
        toggleOnInput('radio', 'howIsFundingManaged', 'Plan managed', '.group-plan-managed-by');
        toggleOnInput('radio', 'howIsFundingManaged', 'Self-managed', '.group-plan-managed-by', false);

        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request on behalf of someone else', '.referrer-full-name');
        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request on behalf of someone else', '.referrer-relationship');
        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request on behalf of someone else', '.referrer-contact-details');
        
        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request for my own support', '.referrer-full-name', false);
        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request for my own support', '.referrer-relationship', false);
        toggleOnInput('radio', 'whoRequestFor', 'I am submitting this request for my own support', '.referrer-contact-details', false);

        toggleOnInput('radio', 'meetAndGreetContact', 'The Participant Directly', '.meet-and-greet-contact', false);
        toggleOnInput('radio', 'meetAndGreetContact', 'The Referrer', '.meet-and-greet-contact', false);
        toggleOnInput('radio', 'meetAndGreetContact', 'Other', '.meet-and-greet-contact');

        document.querySelectorAll('.wf-group.hidden').forEach(group => {
            group.hidden = true;
            group.classList.remove('hidden');
        });

        document
          .querySelectorAll('input[type="checkbox"][required="required"]')
          .forEach((el) => el.removeAttribute("required"));
    }
});

if (module.hot) {
    module.hot.accept();
}
